import './FeaturedStyles.css'
import WorkCart from './WorkCart'
import img1 from "../pictures/work1.png"
import img2 from "../pictures/work2.png"
import img3 from "../pictures/work3.png"
import img4 from "../pictures/work4.jpg"

// import FWorks from './WorkCardData'

export const FWorks = [
    {
        id : 0,
        imgsrc : img1,
        title: "JS + GSAP Animations",
        text : "Scroll-triggered animation uses GSAP, JavaScript, and CSS to create dynamic, smooth visual effects that activate as users scroll through sections.",
        view : "https://capsulesanimation.netlify.app",
        source : "https://github.com/SimunBiswas/assignment-webitof.git"
    },
    {
        id : 1,
        imgsrc : img2,
        title: "Simplify Documents",
        text : "A React.js and Bootstrap-based document manager with mobile OTP login and API-powered file upload and retrieval.",
        view : "https://dmsallsoft.netlify.app",
        source : "https://github.com/SimunBiswas/Data-Management-System.git"
    },
    {
        id : 2,
        imgsrc : img4,
        title: "AI Content Generator",
        text : "An AI-powered content generator using React.js, Tailwind CSS, and OpenAI API to create, edit, and display dynamic text outputs.",
        view :"none", 
        source : "https://github.com/SimunBiswas/ai-con-ass.git"
    },
    {
        id : 3,
        imgsrc : img3,
        title: "Next.js + FramerMotion",
        text : "Scroll-triggered animation uses GSAP, JavaScript, and CSS to create dynamic, smooth visual effects that activate as users scroll through sections.",
        view :"https://avinashmasih.com", 
        source : "https://github.com/SimunBiswas/portfolio_new"
    },
    
 ] 
console.log(FWorks)

const Featured = () => {
  return (
    <div className='projects'>
      <h1>Work in progress</h1>
      <div className='project-container'>
        {
            FWorks.map((work, id) => {
                return <WorkCart key={id} {...work}/>
            })
        }
      </div>
    </div>
  )
}

export default Featured
